import React from 'react';
import styles from '../static/styles/RewardClaimPopup.module.css';
import goldCoinsImage from '../static/img/imageGoldCoins.svg';

const RewardClaimPopup = ({ isOpen, onClose, credits = 15 }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.popupOverlay} onClick={onClose}>
      <div className={styles.popupContent} onClick={(e) => e.stopPropagation()}>
        <h2 className={styles.title}>Congratulations!</h2>
        <div className={styles.coinsContainer}>
          <div className={styles.glitterParticle} />
          <div className={styles.glitterParticle} />
          <div className={styles.glitterParticle} />
          <div className={styles.glitterParticle} />
          <div className={styles.glitterParticle} />
          <img src={goldCoinsImage} alt="Gold Coins" className={styles.coinsImage} />
        </div>
        <div className={styles.credits}>{credits} Credits</div>
        <button className={styles.rewardButton} onClick={onClose}>
          Here is your daily login reward
        </button>
      </div>
    </div>
  );
};

export default RewardClaimPopup;